<template>
    <div>
        <b-card>
          
            <b-media>
                <b-img slot="aside" src="/img/question-mark.jpg" width="60" height="60" alt="placeholder" />

                <!-- Editar y eliminar -->
                <div v-if="!modificar">
                    <b-button-group size="sm" class="pull-right">
                        <b-button 
                            :variant="pregunta.visible ? 'outline-success' : 'outline-secondary'"
                            v-b-tooltip.hover :title="pregunta.visible ? 'Visible en la página' : 'No visible en la página'"
                            @click="cambiaVisible()">
                            <i :class="pregunta.visible ? 'fa fa-lg fa-globe': 'fa fa-lg fa-globe'"></i>
                        </b-button>

                        <b-button 
                            v-if="puedeModificar"
                            variant="outline-secondary"
                            v-b-tooltip.hover title="Modificar documento"
                            @click="modificaForm()">
                            <i class="fa fa-pencil fa-lg"></i>
                        </b-button>
                        <b-button 
                            v-if="puedeEliminar"
                            variant="outline-secondary"
                            @click="eliminaDocumento()"
                            v-b-tooltip.hover 
                            title="Eliminar documento">
                            <i class="fa fa-trash fa-lg"></i>
                        </b-button>
                    </b-button-group>

                    <h5 class="mt-0">{{pregunta.titulo}}</h5>
                    <div v-html="pregunta.respuesta"></div>

                </div>

                <div v-else>
                    <b-row>
                        <b-col lg="12">
                            <div role="group">
                                <label for="inputLive">Pregunta:</label>
                                <b-form-input id="inputLive"
                                    v-model="pregAux.titulo"
                                    type="text"
                                    :state="preguntaValida"
                                    aria-describedby="inputLiveFeedback"
                                    placeholder="Ingrese pregunta"></b-form-input>
                                <b-form-invalid-feedback id="inputLiveFeedback">
                                <!-- This will only be shown if the preceeding input has an invalid state -->
                                Ingrese una pregunta válida
                                </b-form-invalid-feedback>
                            </div>
                        </b-col>

                        <b-col lg="12">
                            <div role="group">
                                <label for="inputLive">Respuesta:</label>
                                <vue-ckeditor 
                                    v-model="pregAux.respuesta" 
                                    :config="editorConfig" 
                                    />
                            </div>
                        </b-col>

                        <b-col sm="6" lg="6">
                            <br>
                            <b-button 
                                variant="secondary"
                                size="sm"
                                @click="modificar = false">
                                Cancelar
                            </b-button>
                        </b-col>
                        <b-col sm="6" lg="6">
                            <br>
                            <b-button 
                                class="pull-right"
                                variant="primary"
                                size="sm"
                                @click="modificaPregunta()">
                                Modificar
                            </b-button>
                        </b-col>
                    </b-row>
                </div>
            </b-media>
          
        </b-card>
    </div>
</template>

<script>
import axios from 'axios'
import Loader from '../../Loader'
import { mapGetters } from "vuex";

import VueCkeditor from 'vue-ckeditor2';

export default {
  name: 'FAQPregunta',
  components: {
    Loader,
    VueCkeditor
  },
  props: ['pregunta'],
  computed: {
    ...mapGetters([
      "httpURL",
      "sessionToken",
      "permisos",
      "role"
    ]),
    preguntaValida(){
        return this.pregAux.titulo.length < 20 ? false : null;
    },
    respuestaValida(){
        return this.pregAux.respuesta.length < 20 ? false : null;
    },
    puedeModificar(){
        if( this.role == 'administrador' || this.permisos.findIndex(x => x.numero === 120) >= 0 )
            return true;
        else
            return false;
    },
    puedeEliminar(){
        if( this.role == 'administrador' || this.permisos.findIndex(x => x.numero === 121) >= 0 )
            return true;
        else
            return false;
    }
  },
  data: function () {
    return {
        enviando: false,
        modificar: false,
        pregAux:{},
        editorConfig: {
        toolbar: [
          ['Bold', 'Italic', 'Underline', 'Strike', 'Subscript', 'Superscript'],
          ['NumberedList','BulletedList','JustifyLeft','JustifyCenter','JustifyRight','JustifyBlock','TextColor','BGColor'],
          ['Link','Table','SpecialChar','Styles','Format','Font','FontSize'],
          ['Cut','Copy','Paste','PasteText','PasteFromWord','Undo','Redo']
        ],
        height: 300
      }
    }
  },
  methods: {
    cambiaVisible(){
        if( this.puedeModificar ){
            this.enviando = true;
            axios.put(this.httpURL+'/transparencia/faq/visible/'+this.pregunta._id,
                    {},
                    {headers: {token:this.sessionToken}})
                .then(res => {
                    this.pregunta.visible = !this.pregunta.visible;
                    this.enviando = false;
                    this.$notify({ group: 'foo', type:"success", duration:2500, speed: 1000,
                        text: res.data.mensaje });
                })
                .catch(error => {
                    this.enviando = false;
                    if(error.response){
                        this.error = error.response.data.mensaje;
                        //console.log(error.response);
                        this.$notify({ group: 'foo', type:"error", duration:2500, speed: 1000,
                            text: error.response.data.mensaje });
                    }else if( error.request){
                        this.$notify({ group: 'foo', type:"error", duration:2500, speed: 1000,
                            text: 'No se pudo establecer una conexión al servidor.' });
                    }
                });
        }
    },
    modificaForm(){
        this.pregAux = this.$_.clone(this.pregunta);
        this.modificar = true;
    },
    modificaPregunta(){
        this.enviando = true;
        axios.put(this.httpURL+'/transparencia/faq/'+this.pregunta._id,
                {titulo:this.pregAux.titulo, respuesta:this.pregAux.respuesta},
                {headers: {token:this.sessionToken}})
            .then(res => {
                this.pregunta.titulo = this.pregAux.titulo;
                this.pregunta.respuesta = this.pregAux.respuesta;
                this.enviando = false;
                this.modificar = false;
                this.$notify({ group: 'foo', type:"success", duration:2500, speed: 1000,
                    text: res.data.mensaje });
            })
            .catch(error => {
                this.enviando = false;
                if(error.response){
                    this.error = error.response.data.mensaje;
                    //console.log(error.response);
                    this.$notify({ group: 'foo', type:"error", duration:2500, speed: 1000,
                        text: error.response.data.mensaje });
                }else if( error.request){
                    this.$notify({ group: 'foo', type:"error", duration:2500, speed: 1000,
                        text: 'No se pudo establecer una conexión al servidor.' });
                }
            });
    },
    eliminaDocumento(){
            swal({
                    icon: 'info',
                    title: 'Área protegida',
                    text: 'Esta acción requiere de tu contraseña:',
                    content: {
                    element: "input",
                    attributes: {
                    placeholder: "Ingrese...",
                    type: "password",
                }
                },
                    closeOnClickOutside: true,
                    button: {
                    text: "Confirmar",
                    closeModal: false,
                },
            })
            .then(password => {
                if (!password){
                    swal.close();
                }else{
                    this.enviando = true;
                    axios.delete(this.httpURL+'/transparencia/faq/'+this.pregunta._id,
                            {data:{password},headers: {token:this.sessionToken}})
                        .then(res => {
                            swal.close();
                            this.$emit('preguntaEliminada',this.pregunta._id);
                            this.enviando = false;
                            this.$notify({ group: 'foo', type:"success", duration:2500, speed: 1000,
                              text: res.data.mensaje });
                        })
                        .catch(error => {
                            this.enviando = false;
                            swal.close();
                            if(error.response){
                                this.error = error.response.data.mensaje;
                                //console.log(error.response);
                                this.$notify({ group: 'foo', type:"error", duration:2500, speed: 1000,
                                    text: error.response.data.mensaje });
                            }else if( error.request){
                                this.$notify({ group: 'foo', type:"error", duration:2500, speed: 1000,
                                    text: 'No se pudo establecer una conexión al servidor.' });
                            }
                        });
                }
            });
        }
  }
}
</script>

